var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.toggle_filters}},[(_vm.filters_active)?_c('v-badge',{attrs:{"dot":"","color":"green"}},[_c('v-icon',[_vm._v("mdi-filter")])],1):_c('v-icon',[_vm._v("mdi-filter-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }